import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    EnviarSolicitudViewModel,
    TwSolicitudCamValidationViewModel,
    TwSolicitudCamViewModel,
    TwSolicitudCamViewModelBase,
    TwSolicitudCamViewModelExtended,
    ValidacionAceptacionSolicitudViewModel,
} from '../../types/solicitudcam-datosbasicos.types';

@Injectable()
export class SolicitudCamService {
    private solicitudCamEndpoint = this.baseUrl + 'api/campanias/solicitudcam/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getSolicitudCam(id: number): Observable<TwSolicitudCamViewModel> {
        return this.http.get<TwSolicitudCamViewModel>(this.solicitudCamEndpoint + id);
    }

    getSolicitudCamExtended(id: number): Observable<TwSolicitudCamViewModelExtended> {
        let url = this.solicitudCamEndpoint + 'extended/' + id;
        return this.http.get<TwSolicitudCamViewModelExtended>(url);
    }

    getSolicitudCamForValidation(id: number): Observable<TwSolicitudCamValidationViewModel> {
        let url = this.solicitudCamEndpoint + 'forValidation/' + id;
        return this.http.get<TwSolicitudCamValidationViewModel>(url);
    }

    saveSolicitudCam(solicitudCam: TwSolicitudCamViewModel): Observable<any> {
        // delete model.Descripcion;  // Para forzar un fallo en el backend y ver que pasa en el catchError
        if (solicitudCam?.Id) {
            return this.editSolicitudCam(solicitudCam);
        }
        // NO se envían éstos campos en la creación. Solo necesarios en frontend
        delete solicitudCam.Codigo;
        delete solicitudCam.EstadoSolicitudCam;
        delete solicitudCam.FechaCreacion;
        delete solicitudCam.Id;
        delete solicitudCam.IdEstadoSolicitudCam;
        delete solicitudCam.IdUsuario;

        return this.createSolicitudCam(solicitudCam as TwSolicitudCamViewModelBase);
    }

    anularSolicitudCam(id: number): Observable<TwSolicitudCamViewModel> {
        let url = this.solicitudCamEndpoint + 'anularSolicitudCam/' + id;
        return this.http.get<TwSolicitudCamViewModel>(url);
    }

    private createSolicitudCam(solicitudCam: TwSolicitudCamViewModelBase): Observable<any> {
        // solicitudCam.Id = 1121; // Para forzar un fallo en el backend y ver que pasa en el catchError
        return this.http.post<TwSolicitudCamViewModelBase>(this.solicitudCamEndpoint, solicitudCam);
    }

    private editSolicitudCam(solicitudCam: TwSolicitudCamViewModel): Observable<any> {
        // solicitudCam.Id = null; // Para forzar un fallo en el backend y ver que pasa en el catchError
        return this.http.put<TwSolicitudCamViewModel>(this.solicitudCamEndpoint, solicitudCam);
    }

    deleteSolicitudCam(idSolicitudCam: number, idTipoSolicitudCam: number): Observable<any> {
        return this.http.delete<TwSolicitudCamViewModel>(this.solicitudCamEndpoint + idSolicitudCam + '/' + idTipoSolicitudCam);
    }

    enviar(model: EnviarSolicitudViewModel): Observable<any> {
        return this.http.put<any>(this.solicitudCamEndpoint + 'enviar/', model);
    }

    validar(payload: ValidacionAceptacionSolicitudViewModel): Observable<any> {
        return this.http.put<ValidacionAceptacionSolicitudViewModel>(this.solicitudCamEndpoint + 'validar/', payload);
    }

    aceptar(payload: ValidacionAceptacionSolicitudViewModel): Observable<any> {
        return this.http.put<ValidacionAceptacionSolicitudViewModel>(this.solicitudCamEndpoint + 'aceptar/', payload);
    }
}
